import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { LayoutService } from '../../../../../_metronic/core';
import { UserModel } from '../../../../../modules/auth/_models/user.model';
import { AuthService } from '../../../../../modules/auth/_services/auth.service';
import { HelperServices } from 'src/app/pages/_services/helper.services';

function getCurrentURL(location) {
  return location.split(/[?#]/)[0];
}

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent implements OnInit {
  ulCSSClasses: string;
  rootArrowEnabled: boolean;
  location: Location;
  headerMenuDesktopToggle: string;
  headerMenuSelfDisplay = true;
  user$: Observable<UserModel>;
  _user:UserModel;
  permissionMenu: any;
  cotizadorLink: any = "";
  constructor(private layout: LayoutService, private loc: Location, private auth: AuthService,public helperServices: HelperServices,) {
    this.location = this.loc;
  }

  ngOnInit(): void {
    this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];
    this.helperServices.getLinkCotizador().then(response => {
      if(response[0]) {
        this.cotizadorLink = response[0].LinkCotizador;
      }
    });
    this.ulCSSClasses = this.layout.getStringCSSClasses('header_menu_nav');
    this.rootArrowEnabled = this.layout.getProp('header.menu.self.rootArrow');
    this.headerMenuDesktopToggle = this.layout.getProp(
      'header.menu.desktop.toggle'
    );
    this.headerMenuSelfDisplay = this.layout.getProp(
      'header.menu.self.display'
    );
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.user$.subscribe(user=> {
      this._user = user;
     });
  }

  getMenuItemActive(url) {
    return this.checkIsActive(url) ? 'menu-item-active' : '';
  }

  checkIsActive(url) {
    const location = this.location.path();
    const current = getCurrentURL(location);
    if (!current || !url) {
      return false;
    }

    if (current === url) {
      return true;
    }

    if (current.indexOf(url) > -1) {
      return true;
    }

    return false;
  }


  openDropdowm(selector) {
      var li = (document.getElementById(selector) as HTMLLIElement)

      if(li.style.display == "none") {
        li.style.display = "block";
      }
      else {
        li.style.display = "none";
      }

      console.log(li.style.display);
  }
}
